// import axios from '@/utils/axios'
// import {prop} from 'ramda'
// const SET_CURRENT_ORGANIZATION = 'set_current_organization'
// const SET_CURRENT_ORGANIZATION_ID = 'set_current_organization_id'
const SET_CURRENT_GETSETUP_BUTTON_CLICK_COUNT = 'set_getsetup_button_click_count'

// initial state
const setInitialState = () => ({
    // Data of the current organization
    // currentOrganizationId: null,
    // currentOrganization: {},
    currentGetsetupButtonClickCount:0
})

const state = setInitialState()

const getters = {
  // currentOrganizationId: prop('currentOrganizationId'),
}

const actions = {
    // getCurrentOrganization({commit}, { organizationId }) {
    //     // TODO: bring organizationId from modules/organization then rewrite this action using state
    //     return axios.get(`/v1/organizations/${organizationId}/`)
    //     .then(response => commit(SET_CURRENT_ORGANIZATION, response.data))
    // },
    // setCurrentOrganizationId({ commit }, { organizationId } = {}) {
    //   commit(SET_CURRENT_ORGANIZATION_ID, organizationId)
    // },
    setGetsetupButtonClickCount({ commit }, { getsetupButtonClickCount } = {}) {
      commit(SET_CURRENT_GETSETUP_BUTTON_CLICK_COUNT, getsetupButtonClickCount)
    },
}
const mutations = {
    // [SET_CURRENT_ORGANIZATION](state, currentOrganization ) {
    //   state.currentOrganization = { ...currentOrganization }
    // },
    // [SET_CURRENT_ORGANIZATION_ID](state, organizationId) {
    //   state.currentOrganizationId = organizationId
    // },
    [SET_CURRENT_GETSETUP_BUTTON_CLICK_COUNT](state, getsetupButtonClickCount) {
      state.currentGetsetupButtonClickCount = getsetupButtonClickCount
    },
  }
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }
